import {create} from 'zustand/react'

// Тип состояния хранилища.
export interface TopMenuStoreType {
    // Данные:

    // Нужно ли монтировать верхнее меню страницы?
    visible: boolean

    // Состояние видимости кнопки создания объявления в верхнем меню.
    createAdButton: boolean

    // Обернуть в карточку с белым фоном.
    wrapInCard: boolean

    // Прикрепить к верху страницы.
    stickToTop: boolean

    // Состояние видимости блока кнопок, требующих авторизации пользователя.
    authBlock: boolean

    // Режим личного кабинета для верхнего меню.
    cabinetMode: boolean

    // API:

    // Задать видимость верхнего меню страницы.
    setVisibility: (visible: boolean, options?: TopMenuOptions) => void

}

export type TopMenuOptions = Partial<Pick<
    TopMenuStoreType,
    'createAdButton' | 'wrapInCard' | 'stickToTop' | 'authBlock' | 'cabinetMode'
>>

export const defaultTopMenuOptions: Required<TopMenuOptions> = {
    createAdButton: true,
    wrapInCard: true,
    stickToTop: false,
    authBlock: true,
    cabinetMode: false,
}

// Состояние бокового меню приложения.
export const useTopMenuStore = create<TopMenuStoreType>(
    set => ({
        visible: false,
        createAdButton: true,
        wrapInCard: true,
        stickToTop: false,
        authBlock: true,
        cabinetMode: false,

        // API:

        setVisibility(
            visible: boolean,
            options: TopMenuOptions = {}
        ): void {
            set({
                ...defaultTopMenuOptions,
                ...options,
                visible,
            })
        },

    })
)
